import { Component, Input, OnInit } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

import { ApAnalyticsService, ClickAnalyticsData } from '@ap/analytics';

import { BackgroundThemeService } from './background-theme.service';

/**
 * @ngdoc component
 * @name BackgroundThemeComponent
 * @module BackgroundThemeModule
 *
 * @description
 */
@Component({
    selector: 'background-theme',
    templateUrl: 'background-theme.component.html',
    styleUrls: ['./background-theme.component.scss'],
    standalone: false
})
export class BackgroundThemeComponent implements OnInit {
    @Input()
    public name: string;

    public image: string;
    public title: string;
    public text: string;
    public link: string;

    public constructor(
        private readonly backgroundThemeService: BackgroundThemeService,
        private readonly analyticsService: ApAnalyticsService
    ) {}

    public ngOnInit(): void {
        this.backgroundThemeService
            .getBackgroundTheme(this.name)
            .pipe(
                map((imageSearchResponse) => imageSearchResponse?.results[0]?.metadata),
                catchError(() => of(null))
            )
            .subscribe((imageMetadata) => {
                if (imageMetadata) {
                    this.image = imageMetadata.image_url;
                    this.title = imageMetadata.item_metadata.text_title;
                    this.text =
                        imageMetadata.item_metadata.text_1 + imageMetadata.item_metadata.text_2 + imageMetadata.item_metadata.text_3;
                    this.link = imageMetadata.item_metadata.link_url;
                }
            });
    }

    public themaLinkClicked(link) {
        this.analyticsService.push(new ClickAnalyticsData('Link', 'Themalogin Keuze Link', link));
    }
}
